const defaultFile = require(`./default.json`);
const configFile = require(`./${process.env.REACT_APP_ENV}.json`);

const config = name => {
  let resultConfig = { ...defaultFile[name], ...configFile[name] };
  return resultConfig;
};

export default config;
